var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "TheFooter",
    [
      _c("div"),
      _c("div", { staticClass: "ml-auto" }, [
        _c(
          "a",
          {
            directives: [
              {
                name: "b-modal",
                rawName: "v-b-modal.aboutModal",
                modifiers: { aboutModal: true },
              },
            ],
            attrs: { href: "#" },
          },
          [_vm._v(_vm._s(_vm.dtrack.application))]
        ),
        _vm._v(" \n    "),
        _c("span", { staticClass: "mr-1" }, [
          _vm._v("v" + _vm._s(_vm.dtrack.version)),
        ]),
      ]),
      _c("about-modal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }